(function (global) {
  'use strict';

  const sameOption = (candidate, selected, index) => {
    const selectedValue = selected[index];
    return selectedValue == null || candidate.options[index] === selectedValue;
  };

  const findVariant = (variants, selected) => {
    if (!Array.isArray(variants) || !Array.isArray(selected)) return null;
    return variants.find((candidate) => (
      Array.isArray(candidate.options)
      && candidate.options.length === selected.length
      && candidate.options.every((value, index) => value === selected[index])
    )) || null;
  };

  const optionValueState = (variants, selected, optionIndex, value) => {
    const matching = (Array.isArray(variants) ? variants : []).filter((candidate) => (
      Array.isArray(candidate.options)
      && candidate.options[optionIndex] === value
      && candidate.options.every((candidateValue, index) => (
        index === optionIndex || sameOption(candidate, selected, index)
      ))
    ));
    if (matching.length === 0) return 'unavailable';
    return matching.some((candidate) => candidate.available === true) ? 'available' : 'sold_out';
  };

  const purchaseState = (variant) => {
    if (!variant || variant.id == null) {
      return {
        availability: 'unavailable',
        variantId: '',
        variantInputDisabled: true,
        formSubmittable: false,
        dynamicCheckoutEnabled: false,
      };
    }
    const available = variant.available === true;
    return {
      availability: available ? 'available' : 'sold_out',
      variantId: String(variant.id),
      variantInputDisabled: false,
      formSubmittable: available,
      dynamicCheckoutEnabled: available,
    };
  };

  const api = Object.freeze({ findVariant, optionValueState, purchaseState });
  global.MPProductVariantState = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document !== 'undefined') document.dispatchEvent(new Event('mp:variant-state-ready'));
})(typeof globalThis !== 'undefined' ? globalThis : window);
